// External
import { AfterViewInit, Component, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common'
// Internal
import { HideComponentService } from '../../common/services/global/hide-component/hide-component.service';
import { ValuesService } from '../../../app/common/values/values.service';
import { Outlet, OutletStatus, OutletsStatusService } from '../../../app/common/services/core/outlets.status.service';

@Component({
    selector: 'app-page-not-found ',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss']
    // encapsulation: ViewEncapsulation.Native
})
export class PageNotFoundComponent implements AfterViewInit {

    errorStatus = '';
    icon = '';
    title = '';

    constructor(
        public  valuesService: ValuesService,
        private readonly hideCompService: HideComponentService,
        private readonly outletsStatusService: OutletsStatusService,
        @Inject(DOCUMENT) private readonly document: any,
    ) {
        this.hideCompService.hideSideMenu();
    }

    goToDefault(){
        this.document.location.href = '/';
    }

    ngAfterViewInit() {
        this.outletsStatusService.setStatus(Outlet.PAGE, OutletStatus.DONE);
    }

}
